import { Table } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type CtsModuleSpecsFragment } from '../../../../../api/fragments/CtsModuleSpecs';
import CtsSettingsAction from './CtsSettingsAction';

export type CtsSettingsTableProps = {
    module: CtsModuleSpecsFragment;
};

export type CtsSettingSpecs = CtsModuleSpecsFragment['ctsSettings'][number];

const CtsSettingsTable = ({ module }: CtsSettingsTableProps) => {
    const { t } = useTranslation(['ctsModuleDetails']);

    const renderActions = useCallback(
        (record: CtsSettingSpecs) => <CtsSettingsAction module={module} setting={record} showUpdate />,
        [module]
    );

    return (
        <Table dataSource={module.ctsSettings} rowKey="id">
            <Table.Column
                key="displayName"
                dataIndex="displayName"
                title={t('ctsModuleDetails:settings.columns.displayName')}
            />
            <Table.Column
                key="identifier"
                dataIndex="identifier"
                title={t('ctsModuleDetails:settings.columns.settingId')}
            />
            <Table.Column
                key="actions"
                align="center"
                render={renderActions}
                title={t('ctsModuleDetails:settings.columns.actions')}
                width={100}
            />
        </Table>
    );
};

export default CtsSettingsTable;
